import { STATE_CODES } from '../stateCodes';

export const isOhioLihtcProgram = (programName: ?string = ''): boolean =>
  String(programName || '')
    .toUpperCase()
    .includes('LIHTC');

const sortLabelList = (labels: string[]) =>
  [...labels].sort((a, b) =>
    a.localeCompare(b, 'en', { sensitivity: 'base', numeric: true }),
  );

const OH_OTHER_ASSET_TYPE_OPTIONS = sortLabelList([
  'Cash/Demand Deposit Accounts',
  'CDs/Time Deposits',
  'Marketable Securities',
  'Real Estate, Equity',
  'Gems/Jewelry',
  'Coins/Stamp Collections',
  'Art/Antiques',
  'Automobiles-Antiques',
  'Lump Sum Receipts (Not Income)',
  'Trust/Available Principal',
  'Other',
]);

const OH_INVESTMENT_PROPERTY_TYPE_OPTIONS = sortLabelList([
  'Gems/Jewelry',
  'Coins/Stamp Collections',
  'Art/Antiques',
  'Automobiles-Antiques',
]);

const OH_ASSET_VERIFICATION_OPTIONS = sortLabelList([
  "Accountant's Affidavit",
  "Bank's Affidavit",
  'Account/Earnings Statement',
  'Published Market Standards',
  'Not Verified',
  'Other',
  "Owner's Affidavit",
  'Qualified Appraisal',
  'Bank/Tax Assessment',
]);

export const ASSET_ALTERNATE_FORM_RULES_BY_STATE = {
  [STATE_CODES.OHIO]: {
    requiresHotmaAndLihtc: true,
    requiresOtherAssetType: true,
    requiresInvestmentPropertyType: true,
    requiresAssetVerification: true,
    assetVerificationColumnLabel: 'Asset Verification',
    otherAssetTypeFieldLabel: 'Type of Asset',
    selectOtherAssetTypeLabel: 'Select Asset Type',
    selectInvestmentPropertyTypeLabel: 'Select Asset Type',
    selectAssetVerificationLabel: 'Select Asset Verification',
    otherAssetTypeOptions: OH_OTHER_ASSET_TYPE_OPTIONS,
    investmentPropertyTypeOptions: OH_INVESTMENT_PROPERTY_TYPE_OPTIONS,
    assetVerificationOptions: OH_ASSET_VERIFICATION_OPTIONS,
  },
};

const normalizeStateCode = (stateCode: ?string): ?string => {
  if (!stateCode) return stateCode;
  const normalized = String(stateCode).toUpperCase();
  if (normalized === 'OH') return STATE_CODES.OHIO;
  return normalized;
};

export const hasStateSpecificAssetFormLayout = (
  stateCode: ?string,
  programName: ?string = '',
  _flags: Object = {},
  isHotmaActive: boolean = false,
): boolean => {
  const rules =
    ASSET_ALTERNATE_FORM_RULES_BY_STATE[normalizeStateCode(stateCode)];
  if (!rules) {
    return false;
  }
  if (rules.requiresHotmaAndLihtc) {
    return isOhioLihtcProgram(programName) && isHotmaActive;
  }
  return true;
};

export const getAssetAlternateFormRulesByState = (
  stateCode: ?string,
  programName: ?string = '',
  flags: Object = {},
  isHotmaActive: boolean = false,
) => {
  const normalizedStateCode = normalizeStateCode(stateCode);
  if (
    !hasStateSpecificAssetFormLayout(
      normalizedStateCode,
      programName,
      flags,
      isHotmaActive,
    )
  ) {
    return null;
  }

  return ASSET_ALTERNATE_FORM_RULES_BY_STATE[normalizedStateCode] || null;
};
